class MobileNav {
  constructor() {
    this.chevronRightIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" fill="#000000" viewBox="0 0 256 256"><path d="M181.66,133.66l-80,80a8,8,0,0,1-11.32-11.32L164.69,128,90.34,53.66a8,8,0,0,1,11.32-11.32l80,80A8,8,0,0,1,181.66,133.66Z"></path></svg>`;

    this.chevronDownIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" fill="#000000" viewBox="0 0 256 256"><path d="M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,53.66,90.34L128,164.69l74.34-74.35a8,8,0,0,1,11.32,11.32Z"></path></svg>`;

    this.mobileNav = document.querySelector('.mobile-menu');
    this.mobileMenuTrigger = document.querySelector('.custom-header__mobile-menu-trigger');
    this.mobileNavSubmenuTogglers = this.mobileNav.querySelectorAll(
      '.mobile-menu__submenu-toggler'
    );
  }

  open() {
    this.mobileNav.classList.remove('custom-invisible');
    this.mobileNav.ariaHidden = 'false';
  }

  close() {
    this.mobileNav.classList.add('custom-invisible');
    this.mobileNav.ariaHidden = 'true';
  }

  openSubmenu(submenu) {
    submenu.classList.remove('submenu-hidden');
    submenu.ariaHidden = 'false';
  }

  closeSubmenu(submenu) {
    submenu.classList.add('submenu-hidden');
    submenu.ariaHidden = 'true';
  }

  bindOverlayClickHandler() {
    this.mobileNav.querySelector('.mobile-menu__overlay').addEventListener('click', () => {
      this.close();
    });

    return this;
  }

  bindOpenerEventListener() {
    const { mobileMenuTrigger } = this;

    if (!mobileMenuTrigger) return;

    mobileMenuTrigger.addEventListener('click', event => {
      event.preventDefault();
      this.open();
    });

    return this;
  }

  bindSubmenuTogglerClickEvent() {
    this.mobileNavSubmenuTogglers.forEach(trigger => {
      trigger.addEventListener('click', event => {
        event.preventDefault();

        const submenu = event.target
          .closest('.mobile-menu__list-item')
          .querySelector('.mobile-menu__submenu');

        const isMenuOpen = !submenu.classList.contains('submenu-hidden');

        if (isMenuOpen) {
          this.closeSubmenu(submenu);
          return;
        }

        this.openSubmenu(submenu);
      });
    });

    return this;
  }

  bindCloseHandler() {
    this.mobileNav
      .querySelectorAll('.mobile-menu__close-wrapper, .mobile-menu__close-wrapper button')
      .forEach(el => el.addEventListener('click', this.close.bind(this)));
  }

  connectToDOM() {
    document.addEventListener('DOMContentLoaded', () => {
      this.bindOpenerEventListener()
        .bindOverlayClickHandler()
        .bindSubmenuTogglerClickEvent()
        .bindCloseHandler();
    });
  }
}

new MobileNav().connectToDOM();
